import { FC, useEffect, useState } from 'react';
import { LoadingStatus } from '../../../../@types/enumsGlobal';
import { DefaultGrid } from '../../../../components/grids/default/defaultGrid';
import { GridSelectorModalWindow } from '../../../../components/modalWindows/GridSelectorModalWindow';
import { IEntitySimpleDTO } from '../../../../libs/coreapi-dto/@types/common';
import { IF3BusAgentDTO } from '../../../../libs/coreapi-dto/service/f3BusCore';
import { F3BusCoreDataProvider } from '../../../../Services/DataProviders/F3BusCoreDataProvider';
import useGridFilter from '../../../../system/hooks/useGridFilter';
import { useAppContext } from '../../../../system/providers/appContextProvider';
import { ConnectionSettingsF3busPlugin } from '../pluginSettings/ConnectionSettingsF3busPlugin';

interface IF3BusAgentGridDTO extends IF3BusAgentDTO {
    idGlobal: string;
    displayName: string;
}

export const F3BusCoreAgentsSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const appContext = useAppContext();
    const f3BusCoreDataProvider = new F3BusCoreDataProvider(appContext.coreApiService);
    const [gridFilter, dispatchGridFilter] = useGridFilter(props.gridFilter);
    const [agents, setAgents] = useState<IF3BusAgentGridDTO[]>([]);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [selectedEntity, setSelectedEntity] = useState<IEntitySimpleDTO>(
        props.selectedEntity ?? {} as IEntitySimpleDTO,
    );
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.InProcess);

    const selectAgent = (row: IGridRow) => {
        const entity = {
            idGlobal: row.idGlobal,
            displayName: row.displayName,
        } as IEntitySimpleDTO;

        setSelectedItem(row);
        setSelectedEntity(entity);
        return entity;
    };

    useEffect(() => {
        const tokenData = localStorage.getItem('TokenData') ?? '';
        const token = JSON.parse(tokenData).accessToken as string ?? '';

        f3BusCoreDataProvider.agents(
            { token },
            (data) => {
                const preparedAgents = data.map((agent) => ({
                    ...agent,
                    idGlobal: String(agent.id),
                    displayName: agent.name,
                }));

                setAgents(preparedAgents);
                setLoadingStatus(preparedAgents.length > 0 ? LoadingStatus.Completed : LoadingStatus.NoData);
            },
            () => {
                setAgents([]);
                setLoadingStatus(LoadingStatus.NoData);
            },
        );
    }, []);

    return (
        <GridSelectorModalWindow
            gridDisplayName="Поставщик"
            entityToPressEnter={selectedEntity}
            ok={{ onClick: () => props.ok?.(selectedEntity) }}
            cancel={{ onClick: () => props.cancel?.() }}
        >
            <DefaultGrid
                showQuantity
                localData
                singleDirectory
                useUiService={false}
                gridId="f3bus-core-agents-selector-grid"
                filter={gridFilter}
                plugin={ConnectionSettingsF3busPlugin}
                data={agents}
                totalCount={agents.length}
                selectedItem={selectedItem}
                loadingStatus={loadingStatus}
                setLoadingStatus={setLoadingStatus}
                hiddenPagination={{ hiddenNumberPage: true, hiddenCountRow: true }}
                onSelect={(row) => row && selectAgent(row)}
                onDoubleClick={(row) => props.ok?.(selectAgent(row))}
                onSort={(column) => dispatchGridFilter({ type: 'sort', payload: column.propertyName })}
                onFilterDelete={(column) =>
                    dispatchGridFilter({ type: 'deleteColumnFilter', payload: column.propertyName })
                }
                onPageNumberChange={(pageNumber) =>
                    dispatchGridFilter({ type: 'changePageNumber', payload: { pageNumber } })
                }
                onNumberPerPageChange={(numberPerPage) =>
                    dispatchGridFilter({ type: 'changeNumberPerPage', payload: { numberPerPage } })
                }
            />
        </GridSelectorModalWindow>
    );
};

export default F3BusCoreAgentsSelectorModal;
